
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.719 6.773c.187.313.343.586.468.82.13.235.264.498.399.79h.101c-.026-.318-.049-.948-.07-1.89-.02-.949-.031-1.803-.031-2.563V2.29c0-.36-.01-.623-.031-.79a.923.923 0 00-.117-.383.556.556 0 00-.227-.21c-.094-.058-.26-.12-.5-.188V.336h2.812v.383c-.234.062-.4.12-.5.172a.736.736 0 00-.234.203 1 1 0 00-.133.375c-.031.166-.047.44-.047.82v8.758h-.976L3.28 3.75c-.27-.453-.463-.784-.578-.992a14.053 14.053 0 01-.32-.617H2.25c.036.4.063 1.127.078 2.18.016 1.046.024 2.09.024 3.132v1.594c0 .349.01.604.03.765.027.162.066.29.118.383a.697.697 0 00.242.235c.11.062.284.125.524.187V11H.414v-.383c.323-.083.54-.174.649-.273.109-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.414.72V.336H2.86l3.86 6.437z","fill":"currentColor"}})])
          )
        }
      }
    